import React from 'react';
import omit from 'lodash/omit';

import Text from './text';

const propTypes = omit(Text.propTypes, ['size']);

export function H1(props) {
  return <Text {...props} size="header1" />;
}
H1.propTypes = propTypes;

export function H2(props) {
  return <Text {...props} size="header2" />;
}
H2.propTypes = propTypes;

export function H3(props) {
  return <Text {...props} size="header3" />;
}
H3.propTypes = propTypes;

export function H4(props) {
  return <Text {...props} size="header4" />;
}
H4.propTypes = propTypes;

export function Small(props) {
  return <Text {...props} size="small" />;
}
Small.propTypes = propTypes;

export function XSmall(props) {
  return <Text {...props} size="xsmall" />;
}
XSmall.propTypes = propTypes;

export function XXSmall(props) {
  return <Text {...props} size="xxsmall" />;
}
XXSmall.propTypes = propTypes;

export function Large(props) {
  return <Text {...props} size="large" />;
}
Large.propTypes = propTypes;
